// extracted by mini-css-extract-plugin
module.exports = {"page":"SingleColumn_page__e14Pq","top":"SingleColumn_top__UmtwA","main":"SingleColumn_main__DiBoY","mainSlot":"SingleColumn_mainSlot__wEhdk"};